import {css} from 'lit';

export default css`

.nav-toggle {
  overflow: hidden;
  text-indent: 110%;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.75rem;
  height: 3.25rem;
  padding: 0;
  border: 0;
  appearance: none;
  background: transparent;
  text-indent: 300%;
}
.nav-toggle:focus {
  outline: dotted #ffbf00;
  outline-offset: -0.5rem;
}
.nav-toggle__icon--menu {
  position: relative;
  margin-top: 8px;
  margin-bottom: 8px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0;
}
.nav-toggle__icon--menu, .nav-toggle__icon--menu::before, .nav-toggle__icon--menu::after {
  display: block;
  width: 1.4444444444rem;
  height: 3px;
  background-color: #fff;
  outline: 1px solid transparent;
  -webkit-transition-property: background-color, -webkit-transform;
  -moz-transition-property: background-color, -moz-transform;
  -o-transition-property: background-color, -o-transform;
  transition-property: background-color, transform;
  -webkit-transition-duration: 0.3s;
  -moz-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
}
.nav-toggle__icon--menu::before, .nav-toggle__icon--menu::after {
  position: absolute;
  content: "";
}
.nav-toggle__icon--menu::before {
  top: -8px;
}
.nav-toggle__icon--menu::after {
  top: 8px;
}
.nav-toggle--active .nav-toggle__icon--menu {
  background-color: transparent;
}
.nav-toggle--active .nav-toggle__icon--menu::before {
  -webkit-transform: translateY(8px) rotate(45deg);
  -moz-transform: translateY(8px) rotate(45deg);
  -ms-transform: translateY(8px) rotate(45deg);
  -o-transform: translateY(8px) rotate(45deg);
  transform: translateY(8px) rotate(45deg);
}
.nav-toggle--active .nav-toggle__icon--menu::after {
  -webkit-transform: translateY(-8px) rotate(-45deg);
  -moz-transform: translateY(-8px) rotate(-45deg);
  -ms-transform: translateY(-8px) rotate(-45deg);
  -o-transform: translateY(-8px) rotate(-45deg);
  transform: translateY(-8px) rotate(-45deg);
}

`;